import * as React from 'react';
import { Link } from 'react-router-dom';

import { CategoryData } from '../App';
import { getPath, getCategoryLinkID } from './TemplateUtils';
import * as styles from '../css/CategoryPulldown.less';
import { ArrowContainer, Divide, ListStyle, TitleStyle } from '../styles/CategoryPulldown';


interface CategoryPulldownProps {
    categories: Array<CategoryData>;
    currentCategory?: CategoryData;
    basePath: string;
}

interface CategoryPulldownState {
    showAccordian: boolean;
}

export class CategoryPulldown extends React.Component<CategoryPulldownProps, CategoryPulldownState> {
    constructor(props: CategoryPulldownProps) {
        super(props);
        this.state = {showAccordian: false};
    }

    toggleAccordian = function() {
        this.setState({ showAccordian: !this.state.showAccordian });
    };

    closeAccordian = function() {
        this.setState({ showAccordian: false });
    };

    componentWillReceiveProps(nextProps: CategoryPulldownProps) {
        this.closeAccordian();
    }

    render() {
        let accordianStyle = styles.accordian;
        let arrowStyle = styles.arrow;

        if (this.state.showAccordian) {
            accordianStyle += ' ' + styles.accordianOpen;
            arrowStyle += ' ' + styles.arrowOpen;
        }

        let SmCategoriesSuffix = '';
        if (this.props.currentCategory) {
            SmCategoriesSuffix = ' - ' + this.props.currentCategory.short_name;
        }
        return (
            <div>
                <TitleStyle onClick={ (e: any) => this.toggleAccordian() }>
                    Categories <span className="medium">{ SmCategoriesSuffix }</span>
                    <ArrowContainer><div className={ arrowStyle }><i className="icon-chevron-down" /></div></ArrowContainer>
                </TitleStyle>
                <Divide className="btm-18" />
                <div className={ accordianStyle + ' row' }>
                    { this.props.categories.map(category => {
                        const path = getPath(this.props.basePath, category.slug);
                        const sidebarID = getCategoryLinkID(category.slug, 'category-pulldown');

                        let listClassName = styles.listItem;
                        if (this.props.currentCategory && category.slug === this.props.currentCategory.slug) {
                            listClassName = styles.selectedItem;
                        }
                        return <Link to={ path } className={ listClassName } key={ category.slug + '_link' }>
                            <ListStyle id={ sidebarID } className="col-sm-4 col-xs-12" key={ category.slug + '_div' }>
                                { category.short_name }
                            </ListStyle>
                        </Link>;
                    }) }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/CategoryPulldown.tsx